module.exports = __webpack_public_path__ + "static/media/delete_outline_white.a8c81e15.svg";